import { atom } from "jotai"

export const relativeTimeNowAtom = atom(Date.now())
